var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReleaseNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M309.129 247.195H416.297V323.39H309.129V247.195Z",
    fill: "#081F42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.171 244.656H282.35V271.435H175.171V244.656Z",
    fill: "#081F42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.171 112.689H228.752V164.27H175.171V112.689Z",
    fill: "#081F42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M309.129 191.059H416.297V217.012H309.129V191.059Z",
    fill: "#081F42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.171 191.059H282.35V217.012H175.171V191.059Z",
    fill: "#081F42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M255.532 137.488H416.295V164.28H255.532V137.488Z",
    fill: "#081F42"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_199",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 484,
    width: 58,
    height: 56
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.981 484.824H168.687V539.482H111.981V484.824Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.768 501.837L126.682 495.487C128.494 494.466 128.825 495.103 129.859 496.904L142.756 516.895C143.484 518.154 144.13 517.604 145.405 516.885L148.68 514.727C151.946 512.905 156.121 514.042 157.977 517.268L160.653 521.935C161.38 523.194 160.928 524.817 159.653 525.536L153.442 529.014L136.242 538.657C134.956 539.375 133.321 538.929 132.594 537.658L113.197 503.89C112.785 503.172 113.04 502.255 113.768 501.837Z",
    fill: "#081F42"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M300.365 422.705C298.106 427.725 292.2 429.96 287.181 427.697C282.164 425.438 279.929 419.532 282.175 414.516C286.295 405.328 288.384 395.245 288.155 385.062C287.947 375.268 285.603 365.331 280.886 355.949C276.173 346.558 269.613 338.733 261.895 332.718C253.852 326.448 244.532 322.086 234.704 319.898C229.32 318.709 225.932 313.386 227.122 308.015C228.301 302.634 233.634 299.244 239.005 300.433C251.75 303.265 263.817 308.905 274.204 317.008C284.23 324.833 292.712 334.916 298.76 346.984C304.813 359.037 307.839 371.867 308.105 384.575C308.398 397.76 305.699 410.798 300.365 422.705Z",
    fill: "#081F42"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M225.032 363.426C219.648 362.237 216.257 356.914 217.45 351.543C218.639 346.173 223.962 342.772 229.333 343.947C232.274 344.619 235.068 345.552 237.706 346.731C247.132 350.947 254.458 358.263 258.848 367.011C263.234 375.759 264.716 385.989 262.467 396.073C261.847 398.895 260.923 401.699 259.686 404.446C257.423 409.466 251.521 411.711 246.501 409.452C241.482 407.193 239.246 401.287 241.495 396.267C242.163 394.785 242.661 393.279 243.001 391.772C244.204 386.354 243.38 380.789 240.96 375.991C238.554 371.179 234.581 367.192 229.527 364.919C228.116 364.288 226.61 363.777 225.032 363.436V363.426Z",
    fill: "#081F42"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.034 470.011L91.0426 480.79C87.8836 482.576 83.8283 481.458 82.0392 478.299C80.2535 475.15 81.3611 471.092 84.5201 469.296L103.512 458.53C106.671 456.745 110.729 457.862 112.515 461.008C114.311 464.167 113.183 468.226 110.034 470.011ZM77.5341 456.963C74.3751 458.759 70.3164 457.655 68.517 454.482C66.7314 451.323 67.8593 447.278 71.0082 445.479L90.0101 434.713C93.1589 432.917 97.2176 434.035 99.003 437.194C100.803 440.353 99.671 444.412 96.5121 446.208L77.5341 456.963ZM221.067 449.224L166.134 352.384C163.523 347.777 159.209 344.982 153.934 344.499C148.648 343.987 143.669 345.736 140.459 349.965L90.4497 415.759L63.1702 431.227V431.241C58.1267 434.093 56.2558 440.472 58.8832 445.588L51.979 449.513C48.2134 451.653 46.8877 456.475 49.0142 460.231L68.4182 494.421C70.5447 498.187 75.3701 499.513 79.1358 497.376L86.0366 493.46C89.0865 498.334 95.5034 500.01 100.571 497.144L127.847 481.676L209.985 472.489C215.247 471.906 219.306 468.529 221.589 463.741C223.862 458.953 223.678 453.814 221.067 449.224Z",
    fill: "#081F42"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M202.759 396.146L211.449 411.468C219.917 406.669 222.882 395.914 218.08 387.456C213.282 379.001 202.527 376.023 194.059 380.825L202.759 396.146Z",
    fill: "#081F42"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_28_199",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 57,
    width: 429,
    height: 430
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121.447 57H549.999V486.087H121.447V57Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_28_199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.916 431.915C531.916 446.715 516.911 467.707 502.111 467.707C487.324 467.707 471.319 446.715 471.319 431.915H498.111V414.123H471.319V378.331H498.111V360.542H471.319V324.75H498.111V306.944H471.319V235.374H531.916V431.915ZM471.319 217.568V56.8184H123V355.284L128.5 343C131 338.5 134.219 332.816 140.806 331.491L140.806 74.6106H453.526V431.915C453.526 441.685 451.928 454.211 465.782 467.707L232.5 466C232.5 466 231.5 474.5 217.5 483L211.607 485.5H502.111C531.711 485.5 551.695 461.515 551.695 431.915V217.568H471.319Z",
    fill: "#081F42"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseNotes);
export default __webpack_public_path__ + "static/media/ReleaseNotes.ab304745b947a2951ac026ed292ea5dc.svg";
export { ForwardRef as ReactComponent };